import ItemsList from "./ItemsList";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";

const Items = {
    list: ItemsList,
    icon: ShoppingBasketIcon
};

export default Items;
